import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Fragment } from 'react';

export const GenderPieChart = ({ data }: any) => {
  const chartData =
    data?.items?.map((item: any) => ({
      name: item.Name,
      y: item.Percentage,
    })) || [];

  const options: Highcharts.Options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Gender Distribution',
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      pointFormat: '<b>{point.y:.2f}%</b>',
      style: {
        fontSize: '12px',
      },
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.y:.1f} %',
          style: {
            fontSize: '11px',
          },
        },
      },
    },
    series: [
      {
        name: 'Gender',
        colorByPoint: true,
        type: 'pie',
        data: chartData,
      },
    ] as any,
  };

  return (
    <Fragment>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Fragment>
  );
};
